import { render, staticRenderFns } from "./email-template-form.vue?vue&type=template&id=a2882b0a"
import script from "./email-template-form.vue?vue&type=script&lang=js"
export * from "./email-template-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports